import brandclub_colors from "../colors/brandclubColors.js";
const brandclubStyles = {
  customScrollbar: {
    "&::-webkit-scrollbar": {
      height: 5,
      width: 5,
      backgroundColor: "transparent",
      borderRadius: 20,
      position: "absolute",
      zIndex: 99999
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: brandclub_colors.darkBlue1,
      borderRadius: 20
    }
  }
};
export {
  brandclubStyles
};
//# sourceMappingURL=index.js.map
